export default __webpack_public_path__ + "static/bob baker-0196e8a41637de5b952b28183e2abe6a.webp";